// TODO: Focus on only ActionList whatever, no hacky slices
// clean up table

import {
  Button,
  Col,
  Row,
  Spinner,
  Modal,
  Form,
  Table,
  ListGroup
} from "react-bootstrap";
import Error from "../abstractComponents/error";
import { useState, useEffect, useContext } from "react";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { useExportFilesMutation } from "../../backend/hooks/interactive/mutationExportFiles";
import {
  getActionTypeKeyFromValue,
  getQualityCheckStatusKeyFromValue,
  capitalizeCase,
  shortenStringMiddle
} from "../../helpers/stringHelper";
import {
  ActionTypeType,
  QualityCheckStatusUI,
  QualityCheckStatusType,
  GetRepositoryObjectsInput,
  RepositoryTree,
  RepositoryObject
} from "../../backend/types";
import { ActionTypeUI } from "../../backend/types";
import { ActionFileType } from "../../backend/types";
import ErrorBoundary from "../abstractComponents/errorBoundary";
import { TreeViewListFilesInRepo } from "../pmxActivity/treeViewListFilesInRepo";
import { deduplicateByKey } from "../../helpers/interactiveHelper";
import UserManualLink from "../abstractComponents/usermanual";
import { useRepositoryObjects } from "../../backend/hooks/pmxActivity/queryGetRepositoryObjects";
import { PmxActivityDetailsContext } from "../../contexts/pmxActivityDetailsProvider";
import { CustomDifference } from "./interactiveFileTransfer";
import { DifferenceState } from "../../backend/interactiveTypes";

const ALLOWED_EXTERNAL_ACTIONS_KEYS = [
  "ADF_CREATION",
  "PLOT_CREATION",
  "REPORT_CREATION",
  "MODEL_EXECUTION",
  "OTHER_ACTION"
];

type ActionFile = CustomDifference & {
  path: string;
  status: string;
};

const FILE_TYPES = [
  ActionFileType.Input,
  ActionFileType.Output,
  ActionFileType.Describing
];

export function InteractiveFileTransferImportAction(props: {
  environmentId: string;
  selectedRows: CustomDifference[];
  setSuccessMessage: (message: { message: string; id: number } | null) => void;
}) {
  const { activityData } = useContext(PmxActivityDetailsContext);

  const [isActionModalVisible, setIsActionModalVisible] = useState(false);
  const [actionType, setActionType] = useState<ActionTypeUI | undefined>(
    undefined
  );
  const [qualityCheckStatus, setQualityCheckStatus] =
    useState<QualityCheckStatusUI>(QualityCheckStatusUI.NOT_STARTED);
  const [description, setDescription] = useState("");
  const [currentSelectedPathTree, setCurrentSelectedPathTree] = useState("/");
  const [currentSelectedRepoIdTree, setCurrentSelectedRepoIdTree] =
    useState<string>(activityData?.mainRepository.id ?? "");
  const [actionFilesList, setActionFilesList] = useState<ActionFile[]>([]);
  const [philFileList, setPhilFileList] = useState<any[]>([]);

  const { exportFiles, isLoadingExportFiles, errorExportFiles } =
    useExportFilesMutation();

  const {
    callMultipleRepository,
    callRepositoryObjects,
    files,
    treeHierarchy,
    isGetRepositoryObjectsLoading,
    getRepositoryObjectsError,
    foldersAndCount
  } = useRepositoryObjects(activityData?.mainRepository?.id);

  useEffect(() => {
    if (isActionModalVisible && activityData) {
      const repoIds = [
        ...(Array.isArray(activityData.readOnlyRepositories)
          ? activityData.readOnlyRepositories.map((repo: any) => repo.id)
          : []),
        activityData.mainRepository.id
      ];
      const repositoryObjectsInput: GetRepositoryObjectsInput[] = repoIds.map(
        (repoId: string) => ({
          repoId: String(repoId)
        })
      );
      callMultipleRepository(repositoryObjectsInput, false);
    }
  }, [isActionModalVisible]);

  function changeActionType(event: React.ChangeEvent<HTMLSelectElement>) {
    event.preventDefault();
    setActionType(ActionTypeUI[event.target.value as ActionTypeType]);
  }

  function changeQualityCheckedStatus(
    event: React.ChangeEvent<HTMLSelectElement>
  ) {
    event.preventDefault();
    setQualityCheckStatus(
      QualityCheckStatusUI[event.target.value as QualityCheckStatusType]
    );
  }

  const filesToBeDeleted: CustomDifference[] = props.selectedRows?.filter(
    (file: CustomDifference) => file.type === DifferenceState.Deleted
  );

  useEffect(() => {
    const actionFilesList = props.selectedRows
      ?.filter(
        (file: CustomDifference) =>
          file.type === DifferenceState.Added ||
          file.type === DifferenceState.Modified
      )
      .map((uploadFile) => ({
        ...uploadFile,
        path: uploadFile.key,
        status: ActionFileType.Output
      }));
    setActionFilesList(actionFilesList);
  }, [props.selectedRows]);

  const performActionUpload = () => {
    const exportPaths = deduplicateByKey(actionFilesList, "fileName").map(
      (row) => ({
        actionFileType: row.actionFileType,
        path: row.fileName
      })
    );
    const deletePaths = Array.from(
      new Set(
        filesToBeDeleted.map((deleted: CustomDifference) => deleted.fileName)
      )
    );
    const additionalFiles = deduplicateByKey(philFileList, "versionId");

    exportFiles({
      variables: {
        environmentId: props.environmentId,
        exportPaths,
        deletePaths,
        additionalFiles,
        qualityCheckStatus:
          getQualityCheckStatusKeyFromValue(qualityCheckStatus),
        description: description,
        actionType: getActionTypeKeyFromValue(actionType)
      }
    }).then(() => {
      setIsActionModalVisible(false);
      props.setSuccessMessage({
        message: "Exporting files, please check the notification for progress.",
        id: Date.now()
      });
    });
  };

  const onNodeSelectFunction = ({
    path,
    repoId = currentSelectedRepoIdTree
  }: {
    path: string;
    repoId: string;
  }) => {
    if (path.endsWith("/")) {
      callRepositoryObjects({
        variables: {
          repoId: String(repoId),
          location: path
        }
      });
    }

    setCurrentSelectedPathTree(path);
    setCurrentSelectedRepoIdTree(repoId);
  };

  const getActionFileStatus = (path: string) => {
    return actionFilesList.find(
      (actionFile: ActionFile) => path === actionFile.path
    )?.status;
  };

  const changeActionFileStatus = (status: string, path: string) => {
    const foundFile = actionFilesList.find(
      (actionFile: ActionFile) => path === actionFile.path
    );
    foundFile!.status = status;
    setActionFilesList([...actionFilesList]);
  };

  const getPhilFileStatus = (versionId: string) => {
    return philFileList.find(
      (philFile: any) => versionId === philFile.versionId
    )?.status;
  };

  const changePhilFileStatus = (status: string, versionId: string) => {
    const foundFile = philFileList.find(
      (philFile: any) => versionId === philFile.versionId
    );
    foundFile.status = status;
    setPhilFileList([...philFileList]);
  };

  const removeFromPhilFileList = (versionId: string) => {
    setPhilFileList([
      ...philFileList.filter(
        (philFile: any) => versionId !== philFile.versionId
      )
    ]);
  };

  const assignPhilFileToPhil = () => {
    const correctFile = files.find(
      (file: RepositoryObject) => file.name === currentSelectedPathTree
    );

    if (
      !philFileList.find(
        (philFile: RepositoryObject) =>
          correctFile!.versionId === philFile.versionId
      )
    ) {
      setPhilFileList([
        ...philFileList,
        {
          ...correctFile,
          absolutePath: correctFile!.repository.name + "/" + correctFile!.name,
          status: ActionFileType.Input
        }
      ]);
    }
  };

  const uploadActionFiles = actionFilesList.filter(
    (actionFile: ActionFile) => actionFile.status === ActionFileType.Input
  );

  return (
    <>
      <Button
        id="proced_with_import_import_action"
        className="button-secondary float-start ms-2"
        variant="primary"
        onClick={() => {
          setIsActionModalVisible(true);
        }}
      >
        <DriveFolderUploadIcon /> Action Upload
      </Button>
      <Modal
        show={isActionModalVisible}
        onHide={() => {
          setIsActionModalVisible(false);
        }}
        dialogClassName="modal-80w interactive_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Importing files from Interactive into PHIL</Modal.Title>
          <UserManualLink
            url="/usermanual/datatransfer/#action-upload"
            testId="um-ie-action-upload"
            className="align-self-start ms-1"
          />
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <Col className="text-end d-flex justify-content-end gap-2">
              <Button
                variant="outline-primary"
                href="#preview_resulting_actions"
              >
                Go to Preview Resulting Actions
              </Button>
              <Button
                variant="primary"
                disabled={
                  actionType === undefined ||
                  isLoadingExportFiles ||
                  isGetRepositoryObjectsLoading
                }
                onClick={performActionUpload}
              >
                Perform Actions
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Form.Label>
                Action Type<span className="red_form">*</span>
              </Form.Label>
              <Form.Select
                required
                value={getActionTypeKeyFromValue(actionType)}
                onChange={changeActionType}
                key="adf_action_type"
                id="adfActionType"
              >
                <option>--Please Select--</option>
                {Object.entries(ActionTypeUI)
                  .filter((element) =>
                    ALLOWED_EXTERNAL_ACTIONS_KEYS.includes(element[0])
                  )
                  .map((element) => (
                    <option key={element[0]} value={element[0]}>
                      {element[1]}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            <Col xs={3}></Col>
            <Col xs={6}>
              <Form.Group className="mb-3" controlId="upload_description">
                <Form.Label>Upload Description</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Please enter a description"
                  value={description}
                  disabled={isLoadingExportFiles}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Form.Label className="mt-3">Quality Control Status</Form.Label>
            </Col>
            <Col xs={3}></Col>
            <Col xs={6}>
              <Form.Select
                value={String(
                  getQualityCheckStatusKeyFromValue(qualityCheckStatus)
                )}
                onChange={changeQualityCheckedStatus}
                key="ie_external_action_quality_controlled"
                id="externalActionIEQualityControlled"
              >
                {Object.entries(QualityCheckStatusUI).map((element) => (
                  <option key={element[0]} value={element[0]}>
                    {element[1]}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>

          {isLoadingExportFiles ||
            (isGetRepositoryObjectsLoading && (
              <Row className="loading_row">
                <Col className="text-center">
                  <Spinner animation="border" className="spinner_color" />
                  <br />
                  Loading...
                </Col>
              </Row>
            ))}
          <br />
          <br />
          <Row className="action_files overflow-auto vh-100">
            <Col xs={7} className="d-flex flex-column h-100">
              <h3 className="font-weight-normal">Action Files:</h3>
              <div className="overflow-auto flex-grow-1 h-100">
                <ListGroup>
                  {actionFilesList.map((actionFile: ActionFile) => (
                    <ListGroup.Item key={actionFile.path}>
                      <Row>
                        <Col xs={10} title={actionFile.path}>
                          {shortenStringMiddle(actionFile.path, 60)}
                        </Col>
                        <Col xs={2}>
                          <Form.Select
                            value={getActionFileStatus(actionFile.path)}
                            onChange={(
                              event: React.ChangeEvent<HTMLSelectElement>
                            ) => {
                              event.preventDefault();
                              changeActionFileStatus(
                                event.target.value,
                                actionFile.path
                              );
                            }}
                            className="float-end change_file_status"
                            disabled={actionType === ActionTypeUI.UPLOAD}
                          >
                            {FILE_TYPES.map((element) => (
                              <option key={element} value={element}>
                                {element}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}

                  {philFileList.map((philFile: any) => (
                    <ListGroup.Item
                      className="phil_action_upload_div"
                      key={philFile.versionId}
                    >
                      <Row>
                        <Col
                          xs={9}
                          className="phil_action_upload_div_inner"
                          title={philFile.absolutePath}
                        >
                          {shortenStringMiddle(philFile.absolutePath, 50)}
                        </Col>
                        <Col xs={3}>
                          <Form.Select
                            value={getPhilFileStatus(philFile.versionId)}
                            onChange={(
                              event: React.ChangeEvent<HTMLSelectElement>
                            ) => {
                              event.preventDefault();
                              changePhilFileStatus(
                                event.target.value,
                                philFile.versionId
                              );
                            }}
                            className="float-start change_phil_file_status"
                          >
                            <option
                              key={ActionFileType.Input}
                              value={ActionFileType.Input}
                            >
                              Input
                            </option>
                            <option
                              key={ActionFileType.Describing}
                              value={ActionFileType.Describing}
                            >
                              Describing
                            </option>
                          </Form.Select>
                          <Button
                            onClick={() => {
                              removeFromPhilFileList(philFile.versionId);
                            }}
                            variant="link"
                            className="phil_remove_file float-end"
                          >
                            X
                          </Button>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </div>
            </Col>
            <Col xs={1} className="align-self-center">
              <Button
                variant="outline-primary"
                onClick={assignPhilFileToPhil}
                disabled={
                  currentSelectedPathTree.endsWith("/") ||
                  currentSelectedPathTree === ""
                }
                id="link_files"
              >
                {"<<"} Link
              </Button>
            </Col>
            <Col xs={4} className="d-flex flex-column h-100">
              <h3 className="font-weight-normal">
                Additional Unchanged Files:
              </h3>
              <div className="overflow-auto flex-grow-1 h-100">
                {treeHierarchy?.map((repositoryTree: RepositoryTree) => (
                  <ErrorBoundary key={repositoryTree.repository.id}>
                    <TreeViewListFilesInRepo
                      foldersAndCount={foldersAndCount}
                      repositoryTree={repositoryTree}
                      activityData={activityData}
                      onNodeSelect={onNodeSelectFunction}
                      currentSelectedPath={currentSelectedPathTree}
                      currentSelectedRepoId={currentSelectedRepoIdTree}
                    />
                  </ErrorBoundary>
                ))}
              </div>
            </Col>
          </Row>
          <br />
          <br />

          <h3 id="preview_resulting_actions" className="font-weight-normal">
            Preview - Resulting Actions:
          </h3>
          <div className="overflow-auto interactive-row">
            <Table
              responsive
              striped
              bordered
              hover
              size="sm"
              className="resulting_action_preview"
            >
              <thead>
                <tr>
                  <th>Action Type</th>
                  <th>Files</th>
                </tr>
              </thead>
              <tbody>
                {/*************** Delete *******************/}
                {filesToBeDeleted.map((file: CustomDifference, index) => (
                  <tr key={`deleted_${index}`}>
                    <td valign="middle">Hide</td>
                    <td className="resulting_action_preview_div">{file.key}</td>
                  </tr>
                ))}
                {/*************** Upload *******************/}
                {uploadActionFiles.map((file: ActionFile, index: number) => (
                  <tr key={`upload_file_${index}`}>
                    <td valign="middle">Upload</td>
                    <td className="resulting_action_preview_div">
                      {file.path}
                      <span className="float-end">Output</span>
                    </td>
                  </tr>
                ))}

                {/*************** Action Upload *******************/}
                {actionFilesList.map((file: ActionFile, index: number) => (
                  <tr key={`action_file_${index}`}>
                    <td valign="middle">
                      {actionType ? (
                        actionType
                      ) : (
                        <span className="red">Choose Action Type</span>
                      )}
                    </td>
                    <td className="resulting_action_preview_div">
                      {file.path}
                      <span className="float-end">
                        {capitalizeCase(file.status)}
                      </span>
                    </td>
                  </tr>
                ))}
                {philFileList.map((file: any, index: number) => (
                  <tr key={`phil_file_${index}`}>
                    <td className="interactive_phil_file_td">
                      {file.name}
                      <span className="float-end">
                        {capitalizeCase(file.status)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setIsActionModalVisible(false);
            }}
            disabled={isLoadingExportFiles || isGetRepositoryObjectsLoading}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={
              actionType === undefined ||
              isLoadingExportFiles ||
              isGetRepositoryObjectsLoading
            }
            onClick={performActionUpload}
          >
            Perform Actions
          </Button>
        </Modal.Footer>
      </Modal>
      {(errorExportFiles || getRepositoryObjectsError) && (
        <Error error={errorExportFiles || getRepositoryObjectsError} />
      )}
    </>
  );
}
